import { environment } from './environment';

export const applicationVersion: string = `V${environment.version}-${environment.envName}-${environment.hash}`;
